export * from './datetime';
export * from './helpers';
export * from './strings';
export * from './http';
export * from './perf';
export { RequestCanceller } from '@shared/utils/http/request-canceller';

/**
 * @param param
 * @return {*}
 */
export function required(param = undefined) {
    throw new Error(`${param || 'Parameter'} is required`);
}

export function between(value, a, b) {
    const min = Math.min.apply(Math, [a, b]);
    const max = Math.max.apply(Math, [a, b]);

    return value > min && value < max;
}
